import { useEffect } from 'react';
import { isPwaApp } from '../config/appMode';
import {
  checkForServiceWorkerUpdate,
  register,
  scheduleAppReload,
} from '../serviceWorkerRegistration';

const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;

/** Checks for a new build on open / resume and soft-reloads when an update is ready. */
function PwaUpdateManager() {
  useEffect(() => {
    if (!isPwaApp || process.env.NODE_ENV !== 'production') {
      return undefined;
    }

    register({
      onUpdate: () => scheduleAppReload('service-worker-update'),
    });

    const checkForUpdates = () => {
      checkForServiceWorkerUpdate();
    };

    const onControllerChange = () => {
      if (navigator.serviceWorker.controller) {
        scheduleAppReload('controller-change');
      }
    };

    checkForUpdates();

    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        checkForUpdates();
      }
    };

    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', checkForUpdates);
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

    const intervalId = window.setInterval(checkForUpdates, UPDATE_CHECK_INTERVAL_MS);

    return () => {
      document.removeEventListener('visibilitychange', onVisible);
      window.removeEventListener('focus', checkForUpdates);
      navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
      window.clearInterval(intervalId);
    };
  }, []);

  return null;
}

export default PwaUpdateManager;
